import {ElementType, ReactNode, forwardRef} from 'react';
import {cn} from '../lib/utils';

interface NavLinkProps {
    children?: ReactNode;
    active?: boolean;
    as?: ElementType;
    asProps?: object;
    className?: string;
    onCloseClick?: () => void;
}

export const NavLink = forwardRef(
    ({children, className, as: Link = 'a', asProps, active, onCloseClick, ...props}: NavLinkProps, ref) => {
        const navLinkStyles = cn(
            'bg-transparent flex items-center gap-[12px] p-[12px] rounded-[6px] font-[600] text-[1rem] text-[#FFFFFF] px-[12px] py-[8px] hover:bg-[#363F72]',
            {'bg-[#3E4784]': active},
            className,
        );
        return (
            <Link {...props} {...asProps} className={navLinkStyles} ref={ref} role='menuitem' onClick={onCloseClick}>
                {children}
            </Link>
        );
    },
);
